// src/components/FeatureFlagRoute.jsx

import React from 'react';
import FeatureDisabledPage from '../pages/FeatureDisabledPage';

/**
 * Um wrapper de rota que renderiza um componente filho se a feature flag estiver ativa,
 * ou uma página de "feature desativada" caso contrário.
 * 
 * @param {{ isEnabled: boolean, children: React.ReactNode }} props
 */
export function FeatureFlagRoute({ isEnabled, children }) {
  if (isEnabled) {
    return children;
  }

  return <FeatureDisabledPage />;
}
